import React from "react";
import { PlanDetailsSection } from "../@types";

interface PlanDetailSectionProps {
  title: string;
  children: React.ReactNode;
  id?: PlanDetailsSection;
}

const PlanDetailSection: React.FunctionComponent<PlanDetailSectionProps> = ({
  title,
  children,
  id,
}) => {
  return (
    <section>
      <h2
        className="PlanDetailSection__header ds-u-font-size--h3 ds-u-md-font-size--h2"
        id={id}
        tabIndex={-1}
      >
        {title}
      </h2>
      {children}
    </section>
  );
};

export default PlanDetailSection;
